import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormControlNumber } from "common";

//import * as Logging from './Utils/Logging.js'

class VerticalNumberAndLabel extends React.Component {

	state = {
		enabled: true
	}

	constructor() {
		super();
		this._ElemFormControlNumber = React.createRef();
	}

	setIsEnabled(value) {
		//Logging.log('VerticalNumberAndLabel.setIsEnabled : ' + this.state.enabled + ' --> ' + value);
		this._ElemFormControlNumber.current.setIsEnabled(value);
		this.setState({ enabled: value });
	}

	isEnabled() {
		return this.state.enabled;
	}

	render() {
		//console.log(`VerticalNumberAndLabel.render state=${JSON.stringify(this.state)} props=${JSON.stringify(this.props)}`);
		return (
			<Wrapper className="col" disabled={!this.state.enabled} >
				<label disabled={!this.state.enabled} size={this.props.size}>{this.props.text}</label>
				<FormControlNumber
					ref={this._ElemFormControlNumber}
					{...this.props}
				/>
			</Wrapper>
		);
	}

	getValueAsNumber() {
		// console.log(`VerticalNumberAndLabel.getValueAsNumber ${this.props.id}`);
		return this._ElemFormControlNumber.current.getValueAsNumber();
	}

	getValue() {
		// console.log(`VerticalNumberAndLabel.getValue ${this.props.id}`);
		return this._ElemFormControlNumber.current.getValue();
	}

	setValue(value, updateDisplayedText) {
		//console.log(`VerticalNumberAndLabel.setValue ${this.props.id} value=${value} updateDisplayedText=${updateDisplayedText}`);
		this._ElemFormControlNumber.current.setValue(value, updateDisplayedText);
	}

	setStep(value) {
		this._ElemFormControlNumber.current.setStep(value);
	}
	
	getStep() {
		return this._ElemFormControlNumber.current.getStep();
	}

	setMin(value) {
		this._ElemFormControlNumber.current.setMin(value);
	}
	
	getMin() {
		return this._ElemFormControlNumber.current.getMin();
	}

	setMax(value) {
		this._ElemFormControlNumber.current.setMax(value);
	}
	
	getMax() {
		return this._ElemFormControlNumber.current.getMax();
	}

	setHighlight(value) {
		//console.log(`VerticalNumberAndLabel.setHighlight(${value})`, this);
		this._ElemFormControlNumber.current.setHighlight(value);
	}
}

VerticalNumberAndLabel.propTypes = {
	text: PropTypes.string,
	min: PropTypes.number,
	max: PropTypes.number,
	step: PropTypes.number,
	defaultValue: PropTypes.number,
	readonly: PropTypes.bool,
	onChange: PropTypes.func
};

// VerticalNumberAndLabel.defaultProps = {
// 	min: 0,
// 	max: 100,
// 	step: 1,
// 	defaultValue: 5,
// 	readonly: false,
// 	onChange: undefined
// };

const Wrapper = styled.div`
	input {
		text-align: center;
		max-width: 160px;
	}
`;

export default VerticalNumberAndLabel;